module.exports = __webpack_public_path__ + "static/media/4a.9a24cf0c.png";